'use client';

import { Spinner } from '@nextui-org/spinner';

import { CookiesModal } from '@/components/ui/cookies';
import { useIsAdmin } from '@/shared/hooks/is-admin';
import { useIsAuthorizated } from '@/shared/hooks/is-authorizated';
import { NoAuthEmpty } from '@/widgets/empty-states/no-auth-empty';
import { NoPermissions } from '@/widgets/empty-states/no-permissions';

export const PageWrapper = ({
  children,
  className: _className = '',
  pending = false,
  withAuth = false,
  adminPage = false,
}: {
  children: React.ReactNode;
  className?: string;
  pending?: boolean;
  withAuth?: boolean;
  adminPage?: boolean;
}) => {
  const { isAuthorizated, isPending: isAuthorizatedPending } =
    useIsAuthorizated();
  const { isAdmin, isPending: isAdminPending } = useIsAdmin();
  const isPending = isAuthorizatedPending || isAdminPending;

  const viewEmptyState =
    (!isAuthorizated || (!isAdmin && adminPage)) && withAuth;
  const viewSpin = (isPending || pending) && withAuth;
  return (
    <>
      {viewSpin ? (
        <Spinner size="lg" />
      ) : (
        <>
          {viewEmptyState ? (
            <>{!isAuthorizated ? <NoAuthEmpty /> : <NoPermissions />}</>
          ) : (
            <div className="flex flex-col flex-grow gap-4 py-4 p-4 pb-[90px] md:container md:w-full md:gap-8 md:p-0 md:py-7 md:pb-7">
              <>
                {children}
                <CookiesModal />
              </>
            </div>
          )}
        </>
      )}
    </>
  );
};
